import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ErrorLogsState } from './error-logs.reducers';

export const errorLogsState = createFeatureSelector<ErrorLogsState>('errorLogs');

export const errorLogsSelector = createSelector(errorLogsState, errorLogs => errorLogs.errorLogs);
